const LAYOUTS_KEY = "scaffolder.layout.v1";
const LAYOUTS_WRAPPER_KEY = "scaffolder.layouts.wrapper.v1";

export { LAYOUTS_KEY, LAYOUTS_WRAPPER_KEY };
//# sourceMappingURL=keys.esm.js.map
